module.exports = __webpack_public_path__ + "static/wayha-ef23374528a0116de62136cf602bfff5.png";